import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { AntDesign, Entypo, MaterialIcons } from "@expo/vector-icons";
import { useRouter } from "expo-router";

import UserAvatar from "@/Components/Media/User/Images/UserAvatar";
import { formatDistanceStr } from "@/formatting/distance";
import { type UserRestriction } from "@/schemas/user/restriction";

type RestrictionCardProps = {
  item: UserRestriction;
};

function RestrictionCard({ item }: RestrictionCardProps): React.JSX.Element {
  const router = useRouter();

  const profile = item.profile;

  const separation = formatDistanceStr(profile.separation);

  const handleProfilePress = (username: string): void => {
    router.push({
      params: { username: username },
      pathname: "/(main)/shared/profile",
    });
  };

  return (
    <View style={styles.container}>
      <UserAvatar
        avatar={profile.avatar}
        defaultAvatarColor={"black"}
        size={80}
      />
      <View style={styles.infoContainer}>
        <View style={styles.detailItem}>
          <AntDesign name="user" size={20} color="blue" />
          <Text style={styles.detailText}>{profile.username}</Text>
        </View>
        <View style={styles.detailItem}>
          <Entypo name="location" size={20} color="#ff6100" />
          <Text style={styles.detailText}>{separation}</Text>
        </View>
        <View style={styles.connectionsItem}>
          <View style={styles.detailItem}>
            <MaterialIcons name="people" size={20} color="green" />
            <Text style={styles.detailText}>{profile.followerCount}</Text>
          </View>
          <View style={[styles.detailItem, { marginLeft: 10 }]}>
            <MaterialIcons name="person-add" size={20} color="green" />
            <Text style={styles.detailText}>{profile.followingCount}</Text>
          </View>
        </View>
      </View>
      <TouchableOpacity
        style={styles.profileContainer}
        onPress={() => handleProfilePress(profile.username)}
      >
        <Text style={styles.profileText}>Profile</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  connectionsItem: {
    alignItems: "center",
    flexDirection: "row",
  },
  container: {
    alignItems: "center",
    flexDirection: "row",
    padding: 8,
  },
  detailItem: {
    alignItems: "center",
    flexDirection: "row",
    marginBottom: 3,
  },
  detailText: {
    color: "black",
    marginLeft: 5,
  },
  infoContainer: {
    flex: 1,
    marginLeft: 10,
    marginTop: 5,
  },
  profileContainer: {
    backgroundColor: "#c04e74",
    borderRadius: 20,
    marginLeft: "auto",
    padding: 10,
  },
  profileText: {
    color: "white",
  },
});

export default RestrictionCard;
